import { useEffect, useState } from 'react'

/**
 * R161 built the prototype's own theme switch here; R176 retired it. The
 * canonical plumbing is utils/theme.ts plus the navbar ThemeMenu, both
 * ported from master. This hook stays: chart code re-renders when the
 * root data-theme attribute flips, whichever control flips it.
 */

/** True while `<html data-theme="dark">`. Reads the DOM, so it stays
 *  correct no matter which control flips the attribute. */
export const useIsDarkTheme = (): boolean => {
	const [dark, setDark] = useState(
		() => document.documentElement.getAttribute('data-theme') === 'dark'
	)
	useEffect(() => {
		const observer = new MutationObserver(() => {
			setDark(document.documentElement.getAttribute('data-theme') === 'dark')
		})
		observer.observe(document.documentElement, {
			attributes: true,
			attributeFilter: ['data-theme']
		})
		return () => observer.disconnect()
	}, [])
	return dark
}
